import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';

export class DocumentSubCategoryDto extends EpimsBaseEntityDto {
	@IsNotEmpty() DocumentSubCategoryId: string;
	@IsNotEmpty() DocumentSubCategoryName: string;
	@IsNotEmpty() DocumentCategoryId: string;
}
